import React from 'react';
import { useLanguage } from '../hooks/useLanguage';
import Header from '../components/Header.jsx';
import Footer from '../components/Footer.jsx';
import SeoHead from '../components/SeoHead.jsx';

const CookiePolicyPage = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
      <style>{`
        header { background-color: rgb(11, 31, 63) !important; }
      `}</style>
      <Header />
      
      <div className="max-w-4xl mx-auto px-4 pt-32 pb-16 sm:px-6 lg:px-8">
        <SeoHead
          title={`${t('cookiePolicy.title')} | Wownautic`}
          description={t('cookiePolicy.whatAreCookies.content')}
          canonicalPath="/cookie-policy"
        />
        <h1 className="text-4xl font-bold text-gray-900 mb-8">
          {t('cookiePolicy.title')}
        </h1>

        <div className="prose prose-lg max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              {t('cookiePolicy.whatAreCookies.title')}
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              {t('cookiePolicy.whatAreCookies.description')}
            </p>
            <p className="text-gray-700 leading-relaxed">
              {t('cookiePolicy.whatAreCookies.moreInfo')}
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              {t('cookiePolicy.cookiesUsed.title')}
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              {t('cookiePolicy.cookiesUsed.intro')}
            </p>

            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              {t('cookiePolicy.cookiesUsed.ownCookies.title')}
            </h3>
            <ul className="list-disc list-inside text-gray-700 mb-6 space-y-2">
              <li>{t('cookiePolicy.cookiesUsed.ownCookies.session')}</li>
            </ul>

            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              {t('cookiePolicy.cookiesUsed.thirdPartyCookies.title')}
            </h3>
            <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
              <li>
                <strong>Google Analytics:</strong> {t('cookiePolicy.cookiesUsed.thirdPartyCookies.analytics')}
              </li>
              <li>
                <strong>{t('cookiePolicy.cookiesUsed.thirdPartyCookies.socialMedia.title')}:</strong> {t('cookiePolicy.cookiesUsed.thirdPartyCookies.socialMedia.description')}
              </li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              {t('cookiePolicy.disableDelete.title')}
            </h2>
            <p className="text-gray-700 leading-relaxed">
              {t('cookiePolicy.disableDelete.description')}
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              {t('cookiePolicy.additionalNotes.title')}
            </h2>
            <ul className="list-disc list-inside text-gray-700 space-y-3">
              <li>{t('cookiePolicy.additionalNotes.note1')}</li>
              <li>{t('cookiePolicy.additionalNotes.note2')}</li>
              <li>{t('cookiePolicy.additionalNotes.note3')}</li>
              <li>{t('cookiePolicy.additionalNotes.note4')}</li>
            </ul>
          </section>

          <section className="mt-12 p-6 bg-blue-50 rounded-lg">
            <p className="text-gray-700">
              {t('cookiePolicy.contact')}
            </p>
          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default CookiePolicyPage;
